// /******/ (() => { // webpackBootstrap
// class CollapsibleButton extends HTMLElement {
//   constructor() {
//     super();
//     this.THROTTLE_INTERVAL = 100;
//     this.bottomGapHeight = 15;
//     this.contentBlockheight = () => this.nextElementSibling.querySelector('.content').offsetHeight + this.bottomGapHeight + 'px';
//   }

//   connectedCallback() {
//     this.init();
//   }

//   init() {
//     window.wetheme.webcomponentRegistry.register({key: 'collapsible-button'});
//     this.collapsibleContent = this.parentElement.querySelector('.collapsible-content');
//     if(this.nextElementSibling.classList.contains('collapsible-content') && this.parentElement.classList.contains('collapsible-tab')) {

//       // Set initial height based on state
//       this.parentElement.classList.contains('open') ? this.nextElementSibling.style.height = this.contentBlockheight() : this.nextElementSibling.style.height = '60px';

//       // Handle click
//       this.addEventListener('click', this.toggle);

//       // Handle enter key
//       this.addEventListener('keydown', (e) => {
//         if (e.key === 'Enter') {
//           this.toggle();
//         }
//       });

//       // Handle window resize
//       window.addEventListener('resize', this.handleResize.bind(this));

//       // Handle collapsible tab content size change
//       this.nextElementSibling.addEventListener('click', this.resetHeight.bind(this));
//     }
//   }

//   handleResize() {
//     this.throttle(this.resetHeight, this.THROTTLE_INTERVAL);
//   }

//   resetHeight() {
//     if(!this.parentElement.classList.contains('open')) return;
//     this.setTransitionHeight(this.nextElementSibling, false);
//   }

//   toggle() {
//     this.parentElement.classList.contains('open') ? this.hideDetails() : this.showDetails();
//   }

//   showDetails() {
//     this.setTransitionHeight(this.nextElementSibling, false)
//     this.parentElement.classList.add('open');

//     if (this.collapsibleContent) {
//       this.collapsibleContent.addEventListener('transitionend', this.transitionEndHandler.bind(this), {once: true});
//     }
//   }

//   hideDetails() {
//     this.setTransitionHeight(this.nextElementSibling, true)
//     this.parentElement.classList.remove('open');

//     if (this.collapsibleContent) {
//       this.collapsibleContent.style.overflow = 'hidden';
//     }
//   }

//   setTransitionHeight(container, isOpen) {
//     if(isOpen) {
//       container.style.height = '0px';
//     } else {
//       container.style.height = this.contentBlockheight();
//     }
//   }

//   transitionEndHandler(event) {
//     // Check if the transitionend event is for the height property
//     if (event.propertyName === 'height') {
//       this.collapsibleContent.style.overflow = 'visible';
//     }
//   }

//   throttle (callback, time) {
//     if (this.throttleTimer) return;
//     this.throttleTimer = true;
//     setTimeout(() => {
//       callback.call(this);
//       this.throttleTimer = false;
//     }, time);
//   }

// }

// // Only define the custom element if it doesn't already exist
// if (!customElements.get('collapsible-button')) customElements.define('collapsible-button', CollapsibleButton);

// /******/ })()
// ;

class CollapsibleButton extends HTMLElement {

  constructor() {
    super();
    this.bottomGapHeight = 15;
  }

  connectedCallback() {
    this.init();
  }

  init() {

    window.wetheme.webcomponentRegistry.register({ key: 'collapsible-button' });

    if (
      this.nextElementSibling &&
      this.nextElementSibling.classList.contains('collapsible-content') &&
      this.parentElement.classList.contains('collapsible-tab')
    ) {

      this.content = this.nextElementSibling;

      // Default closed state
      if (!this.parentElement.classList.contains('open')) {
        this.content.style.height = "0px";
        this.content.style.overflow = "hidden";
      } else {
        this.content.style.height = this.getContentHeight();
      }

      this.addEventListener("click", this.toggle.bind(this));

      this.addEventListener("keydown", (e) => {
        if (e.key === "Enter") this.toggle();
      });

      window.addEventListener("resize", this.resetHeight.bind(this));

    }
  }

  getContentHeight() {
    const inner = this.content.querySelector(".content");
    return inner.offsetHeight + this.bottomGapHeight + "px";
  }

  toggle() {

    const isOpen = this.parentElement.classList.contains("open");

    if (isOpen) {
      this.close();
    } else {

      // Close other accordions
      document.querySelectorAll(".collapsible-tab.open").forEach((tab) => {

        if (tab !== this.parentElement) {

          tab.classList.remove("open");

          const content = tab.querySelector(".collapsible-content");

          if (content) {
            content.style.height = "0px";
            content.style.overflow = "hidden";
          }

        }

      });

      this.open();

    }

  }

  open() {

    this.parentElement.classList.add("open");

    this.content.style.height = this.getContentHeight();

    this.content.addEventListener(
      "transitionend",
      () => {
        this.content.style.overflow = "visible";
      },
      { once: true }
    );

  }

  close() {

    this.parentElement.classList.remove("open");

    this.content.style.height = "0px";
    this.content.style.overflow = "hidden";

  }

  resetHeight() {

    if (!this.parentElement.classList.contains("open")) return;

    this.content.style.height = this.getContentHeight();

  }

}

if (!customElements.get("collapsible-button")) {
  customElements.define("collapsible-button", CollapsibleButton);
}